import React, { useEffect, useState } from 'react';

const UseRecommendation = () => {
    const [recommendation, setRecommendation] = useState([]);

    useEffect(() => {
        fetch('https://vast-mesa-37329.herokuapp.com/recommendation')
            .then(res => res.json())
            .then(data => setRecommendation(data))
    }, [])
    return [recommendation,setRecommendation];
};

export default UseRecommendation;


